export default __webpack_public_path__ + "static/03.09-4fefd0b3111eac40be1aef0167b9458b.png";